export const tag = {
    schema: {
        title: 'Tag',
        type: 'object',
        properties: {
            type: {
                title: 'Type',
                type: 'string',
                enum: ['standard', 'internal'],
            },
            description: {
                title: 'Description',
                type: 'string',
                format: 'textarea',
            },
        },
    },
};
//# sourceMappingURL=tagJsonEditorConfig.js.map